var map = {
	"./vc-egy-ar/assets/badge-icon.png": "cb8e",
	"./vc-egy-ar/assets/cup-icon.png": "47cc",
	"./vc-egy-ar/assets/document-icon.png": "5283",
	"./vc-egy-ar/assets/exit-icon.png": "3bfb",
	"./vc-egy-ar/assets/finger-icon.png": "ff84",
	"./vc-egy-ar/assets/question-icon.png": "4c28",
	"./vc-egy-ar/assets/rugby-ball-icon.png": "a054",
	"./vc-egy-ar/assets/soccer-ball-icon.png": "5f7e",
	"./vc-egy-ar/assets/soccer-news-icon.png": "74e7",
	"./vc-egy-ar/assets/user-icon.png": "66d9",
	"./vc-egy-ar/assets/win-data-amount-icon.png": "dd1c",
	"./vc-egy-ar/assets/won-data-amount-icon.png": "4d75",
	"./vc-za-en/assets/250-mb-icon.png": "7480",
	"./vc-za-en/assets/badge-icon.png": "514a",
	"./vc-za-en/assets/cup-icon.png": "a530",
	"./vc-za-en/assets/document-icon.png": "52ea",
	"./vc-za-en/assets/exit-icon.png": "e66a",
	"./vc-za-en/assets/finger-icon.png": "a905",
	"./vc-za-en/assets/question-icon.png": "48a5",
	"./vc-za-en/assets/r10-airtime-icon.png": "9851",
	"./vc-za-en/assets/rugby-ball-icon.png": "fcb8",
	"./vc-za-en/assets/soccer-ball-icon.png": "49a8",
	"./vc-za-en/assets/soccer-news-icon.png": "722e",
	"./vc-za-en/assets/user-icon.png": "0d31",
	"./vc-za-en/assets/win-data-amount-icon.png": "c69b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce7c";